import React from 'react';

export const StyleGuide = props => <div>This is the style guide</div>;



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/StyleGuide.js